/* eslint-disable no-multiple-empty-lines */
/* eslint-disable eqeqeq */
import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { Segment, Header, Button, Form, Icon, Message } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';

import ConfigSelect from './ConfigSelect';
import ConfigTable from './ConfigTable';
import CreateConfig from './CreateConfig';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const PAGINATION_PARAMS = {
    name: '',
    pageNumber: 0,
    resultsPerPage: 1000,
};
// props: manipulateConfig(bool)
export default class DocumentTemplateConfiguration extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            faculty: '',
            templateConfig: '',
            template: '',

            faculties: [],
            templateConfigs: [],
            templates: [],

            attributes: [],
            attributeNames: [],
            availableAttributeNames: [],

            currentName: '',
            currentValue: '',
            currentDisplayName: '',

            addMode: false,
            editId: null,
            promptForNewConfig: false,

            error: false,
            errorText: '',
            errorLog: '',
            showMessage: false,

            startDate: new Date(),
            startDateErr: false

        };

        this.onSelectChange = this.onSelectChange.bind(this);
        this.getAttributeName = this.getAttributeName.bind(this);
        this.getAttributeDisplayName = this.getAttributeDisplayName.bind(this);

        this._fetchFaculties = this._fetchFaculties.bind(this);
        this._fetchTemplateConfigurations = this._fetchTemplateConfigurations.bind(this);
        this._fetchAttributes = this._fetchAttributes.bind(this);
        this._fetchAttributesNames = this._fetchAttributesNames.bind(this);
        this._updateAvailableAttributesNames = this._updateAvailableAttributesNames.bind(this);
        this._fetchTemplates = this._fetchTemplates.bind(this);

        this._saveNewAttribute = this._saveNewAttribute.bind(this);
        this._deleteAttribute = this._deleteAttribute.bind(this);
        this._saveEditedAttribute = this._saveEditedAttribute.bind(this);
        this.changeStep = this.changeStep.bind(this);
        this.deleteConfig = this.deleteConfig.bind(this);

        this.countTemplateConfig = this.countTemplateConfig.bind(this);
    }

    componentDidMount() {
        this._fetchFaculties();
        this._fetchTemplates();
        // this._fetchTemplateConfigurations();
        this._fetchAttributes();
    }

    countTemplateConfig(templateConfigs) {
        let tempateIds = [];
        templateConfigs.map(el => (
            tempateIds.push(el.templateId)
        ));
        let uniq = Array.from(new Set(tempateIds));
        if (tempateIds.length !== uniq.length) {
            this.setState({ showMessage: true });
        } else this.setState({ showMessage: false });
    }

    changeStep(toastMess) {
        this.props.changeStep(0);

        if (toastMess) { toast('Konfiguracija je uspješno kreirana.'); }
        // else {
        //     toast('Došlo je do greške! Konfiguracija nije kreirana.');
        // }
        this._fetchTemplateConfigurations();
    }

    deleteConfig(templateConfigurationId) {
        // let { organizationalUnitTemplateConfigurationId } = this.state.templateConfigs.find(el => el.key === this.state.templateConfig);
        // console.log('lll', organizationalUnitTemplateConfigurationId);
        console.log('ooo', templateConfigurationId);
        axios.post(`/template-configuration/use-end/${templateConfigurationId}`)
            .then(res => {
                toast('Arhiviranje konfiguracije je uspješno izvršeno.');
                this._fetchTemplateConfigurations();
            })
            .catch(error => {
                toast('Došlo je do greške! Arhiviranje konfiguracije nije uspjelo.');
            });
    }

    onSelectChange(event, { name, value }) {
        event.preventDefault();
        this.setState({
            [name]: value,
        }, () => {
            if (name === 'faculty') this._fetchTemplateConfigurations();
            else if (name === 'templateConfig') this._fetchAttributes();
        });
    }

    getAttributeName(id) {
        const { attributeNames } = this.state;
        const selected = attributeNames.find(el => el.id === id);
        if (selected && selected.name) return selected.name;
        return '';
    }

    getAttributeDisplayName(id) {
        const { attributeNames } = this.state;
        const selected = attributeNames.find(el => el.id === id);
        if (selected && selected.displayName) return selected.displayName;
        return '';
    }

    _fetchFaculties() {
        axios.get('/graduation-documents/faculties')
            .then(res => {
                const faculties = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                if (faculties.length === 0) {
                    this.setState({ error: true, errorText: 'faculties list was empty' });
                } else {
                    this.setState({
                        faculties,
                        faculty: faculties[0].id
                    }, () => this._fetchTemplateConfigurations());
                }
            })
            .catch(error => this.setState({ error, errorText: 'failed to fetch faculties' }));
    }

    // TODO: if prop manipulateConfig exists fetch all LKP_document_templates
    _fetchTemplateConfigurations() {
        const { faculty } = this.state;
        axios.get(this.props.studentService ? 'template-configuration/templates' : `template-configuration/templates/${faculty}`)
            .then(res => {
                let templateConfigs = res.data.sort((a, b) => b.templateId - a.templateId).map(el => ({
                    ...el,
                    key: el.templateConfigurationId,
                    value: el.templateConfigurationId,
                    text: el.useEnd ? el.name + ' (' + moment(el.useStart).format('D. M. YYYY.') + ' - ' + moment(el.useEnd).format('D. M. YYYY.') + ')'
                        : el.name + ' (' + moment(el.useStart).format('D. M. YYYY.') + ' - danas)'
                }));
                // filter(el => el.useEnd === null)
                // templateConfigs.filter(el => el.useEnd === null);
                // this.setState({ templateConfigs, templateConfig: templateConfigs[0].value });
                this.countTemplateConfig(templateConfigs);
                if (templateConfigs.length === 0) {
                    this.setState({ promptForNewConfig: true });
                    this.setState({ templateConfigs: [], templateConfig: '' });
                } else {
                    this.setState({
                        templateConfigs,
                        templateConfig: templateConfigs.filter(el => el.useEnd === null)[0].value
                    });
                }
            })
            .catch(err => this.setState({ error: true, errorText: `failed to fetch config templates for faculty with id ${faculty}`, errorLog: err.message }));
    }
    _fetchAttributes() {
        if (this.state.templateConfigs.length === 0) return;
        const selectedTemplateConfig = this.state.templateConfigs.find(el => el.templateConfigurationId == this.state.templateConfig);
        const { templateId, templateConfigurationId } = selectedTemplateConfig;
        axios.get(`/template-configuration/attributes/${templateConfigurationId}/${templateId}`)
            .then(res => {
                const attributes = res.data;
                this.setState({ attributes }, () => this._fetchAttributesNames());
            })
            .catch(err => console.log(`failed to fetch attributes for template ${templateId} and templateConfig ${templateConfigurationId}`));
    }
    _fetchAttributesNames() {
        // get template id
        const selectedTemplateConfiguration = this.state.templateConfigs.find(el => el.templateConfigurationId == this.state.templateConfig);
        const { templateId } = selectedTemplateConfiguration;

        axios.get(`template-configuration/attributes/${templateId}`)
            .then(res => {
                const attributeNames = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.displayName
                }));
                this.setState({
                    attributeNames
                }, () => this._updateAvailableAttributesNames());
            });
    }
    _updateAvailableAttributesNames() {
        const { attributeNames } = this.state;
        // const available = attributeNames.filter(el1 => attributes.findIndex(el2 => el2.name === el1.name) === -1);
        const available = attributeNames;

        let allAttributeKeys = available.sort().reduce((accumulator, current) => {
            const dataLength = accumulator.length;
            if (dataLength === 0 || accumulator[dataLength - 1] !== current.key) {
                accumulator.push(current.key);
            }
            return accumulator;
        }, []);

        const uniqueAttributeKeys = allAttributeKeys.filter((val, id, array) => array.indexOf(val) == id);

        const availableAttributes = uniqueAttributeKeys.map(el => ({
            key: el + 1,
            value: el + 1,
            text: this.getAttributeDisplayName(el),
            name: this.getAttributeName(el)
        }));

        this.setState({ availableAttributeNames: availableAttributes });
    }
    _saveNewAttribute(name, displayName, value, engValue) {
        const newAttribute = {
            name, displayName, value, translations: [{ language: { twoLetterCode: 'en' }, value: engValue }]
        };
        const selectedTemplateConfiguration = this.state.templateConfigs.find(el => el.templateConfigurationId == this.state.templateConfig);
        const { templateId, templateConfigurationId } = selectedTemplateConfiguration;
        axios.post(`/template-configuration/attributes/${templateConfigurationId}/${templateId}`, { ...newAttribute })
            .then(res => this._fetchAttributes())
            .catch(error => console.log('could not save new attribute'));
    }
    _saveEditedAttribute(id, name, displayName, value, engValue) {
        // const selectedTemplateConfiguration = this.state.templateConfigs.find(el => el.templateConfigurationId == this.state.templateConfig);
        // const { templateId, templateConfigurationId } = selectedTemplateConfiguration;

        let translations = [{ language: { twoLetterCode: 'en' }, value: engValue }];
        const attributeToUpdate = {
            id, name, displayName, value, translations: engValue ? translations : null
        };
        axios.put('/template-configuration/attributes/', { ...attributeToUpdate })
            .then(res => this._fetchAttributes())
            .catch(error => console.log('could not udpate existing attribute'));
    }
    _deleteAttribute(id) {
        axios.delete(`/template-configuration/attributes/${id}`)
            .then(res => this._fetchAttributes())
            .catch(error => console.log('could not delete attribute'));
    }
    _fetchTemplates() {
        axios.get('document-templates', { params: PAGINATION_PARAMS })
            .then(res => {
                const allTemplates = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.documentType.name
                }));
                const templatesAdmin = allTemplates.filter(el =>
                    el.name === 'degree' || el.name === 'degree_supplement');
                const templatesSService = allTemplates.filter(el =>
                    el.name != 'degree' && el.name != 'degree_supplement' && el.name != 'degree_english' && el.name != 'credentials_report' && el.name != 'student_graded_activity_report'
                    && el.name != 'exam_application' && el.name != 'exam_marks_report' && el.name != 'professor_workload_report' && el.name != 'ou_workload_report'
                    && el.name != 'assistant_workload_report' && el.name != 'ou_questionnaire_statistics' && el.name != 'student_course_implementation'
                    && el.name != 'exam_marks_without_full_name_report' && el.name != 'personal_questionnaire_statistics');
                let templates = [];
                if (this.props.studentService) { templates = templatesSService; } else { templates = templatesAdmin; }
                this.setState({ templates, template: templates[0].id });
            });
    }
    // if manipulateConfig exists in props dont render table but instead render input fields
    // for new config with data dateStart (default today) and dateEnd (default null)
    // checkbox active (default false)

    render() {
        const errorNoTemplate = <div>Nema verzija izvještaja.</div>;
        const selects = (
            <div>
                {/* {this.state.showMessage && */}
                {/* <Message */}
                {/*    error */}
                {/*    header="Imate više od jedne verzije za neki tip dokumenta! Da biste štampali dokumente morate imati samo jednu verziju (konfiguraciju) za svaki tip." */}
                {/* /> */}

                {/* } */}
                <Form>
                    {!this.props.studentService && !this.props.manipulateConfig && <ConfigSelect
                        name="faculty"
                        colWidth={12}
                        simpleName="Fakultet"
                        value={this.state.faculty}
                        data={this.state.faculties}
                        onChange={this.onSelectChange}
                    />}
                    {!this.props.manipulateConfig &&
                    <ConfigSelect
                        name="templateConfig"
                        simpleName="Verzija dokumenta"
                        value={this.state.templateConfig}
                        data={this.props.studentService ? this.state.templateConfigs.filter(el => el.name != 'Dodatak diplomi' && el.name != 'Diploma' && el.name != 'Pristupni podaci' && el.useEnd === null) : this.state.templateConfigs.filter(el => el.useEnd === null)}
                        onChange={this.onSelectChange}
                        idName="templateConfigurationId"
                        transformDisplayNameWithDate
                    />
                    }
                </Form>
                <br />

                {/* {!this.props.manipulateConfig && */}
                {/* <div> */}
                {/*   <Button color="red" basic="true" floated="right" onClick={() => this.deleteConfig()}>Brisanje konfiguracije</Button> */}
                {/*   <br /> */}
                {/*   <br /> */}
                {/*   <br /> */}
                {/* </div> */}
                {/* } */}

                {this.props.manipulateConfig ? <CreateConfig
                    faculty={this.state.faculty}
                    template={this.state.template}
                    studentService={this.props.studentService}
                    changeStep={this.changeStep}
                    templateConfigs={this.state.templateConfigs}
                    name="template"
                    simpleName="Tip dokumenta"
                    value={this.state.template}
                    data={this.state.templates}
                    onChange={this.onSelectChange}
                    idName="id"
                    nameF="faculty"
                    simpleNameF="Fakultet"
                    valueF={this.state.faculty}
                    dataF={this.state.faculties}
                    onChangeF={this.onSelectChange}
                    deleteConfig={this.deleteConfig}
                />
                    : this.state.templateConfig === '' ?
                        errorNoTemplate
                        : <ConfigTable
                            studentService={this.props.studentService}
                            attributes={this.state.attributes}
                            attributeNames={this.state.attributeNames}
                            availableAttributeNames={this.state.availableAttributeNames}
                            saveNewAttribute={this._saveNewAttribute}
                            saveEditedAttribute={this._saveEditedAttribute}
                            deleteAttribute={this._deleteAttribute}
                            fetchAttributes={this._fetchAttributes}
                            fetchAttributesNames={this._fetchAttributesNames}
                        />}
            </div>
        );

        return (
            <div>
                {selects}
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DocumentTemplateConfiguration/DocumentTemplateConfiguration.js